import { useEffect, useId, useRef, useState } from 'react';

export default function EventDescription({ text, eventName }) {
  const id = useId();
  const description = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [text]);

  useEffect(() => {
    const element = description.current;
    let active = true;
    const measure = () => {
      if (!active || !element) return;
      const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
      setOverflows(Number.isFinite(lineHeight) && element.scrollHeight > lineHeight * 4 + 1);
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(element);
    window.addEventListener('resize', measure);
    document.fonts?.ready.then(measure);
    return () => {
      active = false;
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [text]);

  return <div className="event-description-group">
    <p ref={description} id={id} className={`event-description${expanded ? ' event-description--expanded' : ''}`}>{text}</p>
    {overflows && <button type="button" className="event-read-more" aria-expanded={expanded} aria-controls={id}
      aria-label={`${expanded ? 'See less' : 'See more'} about ${eventName}`} onClick={() => setExpanded(value => !value)}>
      {expanded ? 'See less' : 'See more'}
    </button>}
  </div>;
}
